import { useForm } from 'react-hook-form'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent, DialogContentText,
  DialogTitle, Grid,
  TextField
} from '@material-ui/core'

import HookForm from '../../../components/common/HookForm'
import SelectInput from '../../../components/common/inputs/SelectInput'
import TextInput from '../../../components/common/inputs/TextInput'
import { useEventState } from '../../../slices/eventSlice'
import styles from './LocationsTable.module.css'
import { useCreateLocation } from './useCreateLocation'
import React, {useEffect} from "react";
import DateTimeInput from "../../../components/common/inputs/DateTimeInput";
import dayjs from "dayjs";
import { Events, useFetchEvents } from '../../../queries/events/useFetchEvents'
import {useFetchEventSettings} from "../../../queries/events/useFetchEventSettings";

type FormData = {
  id: string
  location: string
  active: string
  opendate: string
  closeddate: string
}
export const LocationsForm = ({ isOpen, setIsOpen, gridParams }) => {
  let { data } = useFetchEvents()

  const formMethods = useForm<FormData>()
  const { reset, watch } = formMethods
  const createMutation = useCreateLocation()
  const eventState = useEventState()
  const title = gridParams ? "Edit Location" : "Create Location"
  const [dialogMsg, setDialogMsg] = React.useState("")

  var { data: eventsettings, isFetching } = useFetchEventSettings(
      Number(eventState.eventId),
      true
  )

  useEffect(() => {
    if (gridParams) {
      reset({
        id: gridParams.id,
        location: gridParams.location,
        opendate: gridParams.opendate,
        closeddate: gridParams.closeddate,
        active: (gridParams ? (gridParams.active ? 'Active' : 'Inactive') : 'Active'),
      })
    }
    else {
      // var curEvent = data.find(event => event.eventid === Number(eventState.eventId))

      reset({ 
        location: '',
        active: 'Active',
        opendate: eventsettings.bidstart,
        closeddate: eventsettings.bidend,
       })
    }
  }, [gridParams, isOpen])

  const checkEndDate = (value: string, watch: Function) => {
    if(new Date(value) > new Date(eventsettings?.end)){
      return 'Location closing date should be before '+ eventsettings.name + ' close date.'
    }
    return new Date(value) >= new Date(watch('opendate')) || 'Location closing date should be after location open date.'
  }
  const checkStartDate = (value: string) => {
    return new Date(value) >= new Date(eventsettings?.start) || 'Location opening date should be after '+ eventsettings.name + ' open date.'
  }

  const onSubmit = async (formData: FormData) => {
    const id = gridParams ? { id: formData.id } : { }

    try {
      await createMutation.mutateAsync({
        description: formData.location,
        opendate: dayjs(formData.opendate).format('YYYY-MM-DDTHH:mm:ss'),
        closeddate: dayjs(formData.closeddate).format('YYYY-MM-DDTHH:mm:ss'),
        active: (formData.active === 'Active'),
        eventid: Number(eventState.eventId),
        type: 'location',
        ...id
      },{
        onSuccess: (data) => {
          const json = JSON.parse(data.data.jsonString)
          if (json.status === "failure") {
            setDialogMsg(json.message)
          }
          else {
            setIsOpen(false)
          }
        }
      })
    } catch {}
  }

  const closeDialog = () => {
    setDialogMsg("")
  }

  return (
    <Dialog open={isOpen}>
      <DialogTitle>{title}</DialogTitle>

      <>
        <Dialog
            open={dialogMsg.length > 0}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {dialogMsg}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDialog}>Ok</Button>
          </DialogActions>
        </Dialog>
      </>

      <DialogContent>
        <HookForm
          methods={formMethods}
          onSubmit={onSubmit}
          className={styles.locationsForm}
          formProps={{ id: 'locations-form' }}>
          <TextInput name="location" label="Location" required />
          <DateTimeInput
              name="opendate"
              label="Open Date"
              defaultValue={new Date().toISOString()} rules={{
                validate: (val) => checkStartDate(val),
              }}
              required={true}
              disabled={!eventsettings.allowcustomlocations}
          />
          <DateTimeInput
              name="closeddate"
              label="Closing Date"
              defaultValue={new Date().toISOString()}
              rules={{
                validate: (val) => checkEndDate(val, watch),
              }}
              disabled={!eventsettings.allowcustomlocations}
              required={true}
          />

          <SelectInput
            name="active"
            label="Status"
            options={[
              { label: 'Active', value: 'Active' },
              { label: 'Inactive', value: 'Inactive' }
            ]}
            includeNone={false}
            required
          />
        </HookForm>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => setIsOpen(false)}>
          Cancel
        </Button>
        <Button
          variant="contained"
          className={styles.submitButton}
          type="submit"
          form="locations-form">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}
